import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import Papa from "papaparse";
import { Helmet } from "react-helmet-async";

function TabsChart() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/uploads/firefox_tab_log.csv")
      .then(response => response.text())
      .then(csvText => {
        Papa.parse(csvText, {
          complete: (result) => {
            const timestamps = [];
            const scores = [];

            result.data.forEach((row, index) => {
              if (row.length === 2 && index > 0) { // Skip header row
                timestamps.push(row[0]); // Timestamp
                scores.push(parseFloat(row[1])); // Tab count
              }
            });

            if (timestamps.length && scores.length) {
              const yMin = Math.min(...scores);
              const yMax = Math.max(...scores);
              const margin = (yMax - yMin) * 0.1 || 0.5; // 10% margin

              setData({
                x: timestamps,
                y: scores,
                yRange: [yMin - margin, yMax + margin]
              });
            }
          },
          header: false, // No headers in CSV
        });
      });
  }, []);

  return (
    <div className="w-screen h-screen">
      <Helmet>
        <title>Tabs | Croquette</title>
      </Helmet>
      {data ? (
        <div className="w-full h-full">
          <Plot
            data={[
              {
                x: data.x,
                y: data.y,
                mode: "lines+markers",
                type: "scatter",
                name: "Number of Tabs",
              }
            ]}
            layout={{
              title: "Number of tabs opened on my browser",
              xaxis: { title: "Date and Time", gridcolor: "#FEE263" },
              yaxis: { title: "Number of Tabs", range: data.yRange, gridcolor: "#FEE263" },
              paper_bgcolor: "#2D085A",
              plot_bgcolor: "#2D085A",
              font: { color: "#FEE263" },
              autosize: true,
            }}
            style={{ width: "100%", height: "100%" }}
            useResizeHandler={true}
          />
        </div>
      ) : (
        <p className="text-gray-700 flex-grow flex items-center justify-center">
          Loading data...
        </p>
      )}
    </div>
  );
}

export default TabsChart;
